import { z } from 'zod'

// One cited field within a citation. `factKey` is the dedupe identity, so a doubly-cited field
// collapses to one. Slices may `.extend()` either variant with their own metadata.
const CitedFactBaseSchema = z.object({
  factKey: z.string(),
})

export const StructuredCitedFactSchema = z
  .object({ ...CitedFactBaseSchema.shape, kind: z.literal('structured'), value: z.string() })
  .strict()
export const FreeTextCitedFactSchema = z
  .object({ ...CitedFactBaseSchema.shape, kind: z.literal('free_text'), quote: z.string(), anchor: z.string() })
  .strict()

export const CitedFactSchema = z.discriminatedUnion('kind', [StructuredCitedFactSchema, FreeTextCitedFactSchema])
export type CitedFact = z.infer<typeof CitedFactSchema>
